import { getStore } from '../store/store';
import BrowserWidthBucket from '../store/schema/BrowserWidthBucket';

export default function getBrowserWidthBucket(): BrowserWidthBucket {
    return getStore().browserWidthBucket;
}
